import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import TaskpaneApp from "./TaskpaneApp";
import ProjectSetupApp from "./components/projectSetup/ProjectSetupApp";
import PdfExportApp from "./components/pdfExport/PdfExportApp";
import { isPdfRoute } from "./pdfExport/pdfDialogBridge";
import ErrorBoundary from "./components/ErrorBoundary";
import { isSetupRoute } from "./structure/dialogBridge";
import { initGlobalErrorCapture } from "./utils/errorLogger";
import "./taskpane.css";

initGlobalErrorCapture();

// Which window this page is: the taskpane itself, or one of the Office dialogs opened from it.
const currentView = () => (isSetupRoute() ? "setup" : isPdfRoute() ? "pdf" : "taskpane");

function Root() {
  const [view, setView] = useState(currentView);
  useEffect(() => {
    const onHash = () => setView(currentView());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  if (view === "setup") return <ProjectSetupApp />;
  if (view === "pdf") return <PdfExportApp />;
  return <TaskpaneApp />;
}

const root = createRoot(document.getElementById("app"));
root.render(
  <ErrorBoundary>
    <Root />
  </ErrorBoundary>
);
